export { default } from "bullitttime-embermodelsevent/adapters/entry";
